<div
  #container
  role="list"
  class="relative flex h-6 min-w-3.5 gap-0.5 overflow-hidden rounded-md"
  [sbTooltip]="tooltipTemplate"
  [sbTooltipPlacement]="tooltipPlacement"
  [sbTooltipMaxWidth]="'30rem'"
  [sbTooltipDisabled]="!items().length && !restItem()"
>
  @for (item of items(); track item.id) {
    <span
      #stackedBar
      role="listitem"
      [attr.aria-label]="barLabel(item)"
      [class]="item.percentage ? 'min-w-1.5' : 'hidden'"
      [style]="{ backgroundColor: item.color, width: item.percentage + '%' }"
    >
    </span>
  }
  @if (restPercentage()) {
    <span
      #stackedBar
      role="listitem"
      [attr.aria-label]="restBarLabel()"
      class="min-w-1.5 flex-1"
      [style]="{ backgroundColor: restItem()?.color ?? null }"
      [class]="{ 'bg-alt': !restItem()?.color }"
    >
    </span>
  }
  @if (compressedBarPosX(); as compressedBarLeft) {
    <div
      aria-hidden="true"
      class="absolute inset-y-0 right-0 bg-surface"
      [style]="{ left: compressedBarLeft + 'px' }"
    ></div>
  }
</div>

@if (compressLegendItems().length) {
  <sb-legend
    class="mt-3 mb-0 inline-block"
    [items]="visibleLegendItems()"
    [restItem]="{ label: ('Others' | translate) }"
  />
} @else {
  <sb-legend class="mt-3 mb-0 inline-block" [items]="visibleLegendItems()" [restItem]="restItem()" />
}

<ng-template #tooltipTemplate>
  <ul
    id="tooltip-list"
    class="reset-ul flex flex-col gap-2 px-3 py-2 text-base font-medium whitespace-nowrap text-overlay-strong"
  >
    @for (item of visibleLegendItems(); track item.id) {
      <sb-horizontal-stacked-bar-tooltip-item [item]="item" />
    }

    @if (compressLegendItems().length) {
      <li>{{ 'Others' | translate }}</li>
    }
    @for (item of compressLegendItems(); track item.id) {
      <sb-horizontal-stacked-bar-tooltip-item [item]="item" />
    }
    @if (restItem()) {
      <sb-horizontal-stacked-bar-tooltip-item [item]="restItem()" />
    }
  </ul>
</ng-template>
